<template>
  <div>
    <div class="custom-container">
      <b-row>
        <b-col sm="12">
          <card class="p-0">
            <template class="p-0" v-slot:headerTitle>
              <div class="d-flex flex-column align-items-start">
                <h3 class="card-title p-0">
                  <b>Lista de Cups y Cies</b>
                </h3>
              </div>
            </template>
            <div class="row m-3">
              <div class="col-2 px-0">
                <h4 class="mb-2"><b>selecciona opción:</b></h4>
                <b-select v-model="itemSeleccionado" class="form-control bg-dark personalizado" :options="listaCups" text-field="mes" value-field="id" />
              </div>
              <div class="col-6 px-0 mt-3">
                <div class="d-flex">
                  <vs-button primary class="px-2 py-1" @click="obtenerCup()" id="sendform2">
                    <i class="fas fa-search mr-1"></i>
                  </vs-button>
                </div>
              </div>
            </div>

            <div class="px-3 pt-3">
              <!-- aqui va la tablsa -->

              <div class="p-2" v-if="listaRegistros.length > 0">
                <div>
                  <vs-button v-if="listaRegistros.length" icon success class="mx-1" @click="generateReport">
                    <i class="fas fa-file-excel mr-1"></i>
                    Exportar Tabla
                  </vs-button>
                </div>
                <b-table
                  id="datatable_ttos"
                  striped
                  bordered
                  hover
                  responsive
                  small
                  :items="listaRegistros"
                  :fields="Columnas"
                  class="text-center"
                  :per-page="perPage"
                  :current-page="currentPage"
                >
                </b-table>
                <b-pagination v-model="currentPage" :total-rows="listaRegistros.length" :per-page="perPage" align="center" class="my-3"></b-pagination>
              </div>
            </div>
          </card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import * as XLSX from "xlsx";

export default {
  name: "registroServicios",
  components: {},
  data() {
    return {
      itemSeleccionado: null,

      listaRegistros: [],
      Columnas: [
        { key: "Id2", sortable: true },
        { key: "noFactura", sortable: true },
        { key: "codigoPrestador", sortable: true },
        { key: "tipoDocumento", sortable: true },
        { key: "identificacion", sortable: true },
        { key: "fechaProcedimiento", sortable: true },
        { key: "numeroAutorizacion", sortable: true },
        { key: "cups", sortable: true },
        { key: "ambito", sortable: true },
        { key: "finalidad", sortable: true },
        { key: "personalAtiende", sortable: true },
        { key: "cie10qx", sortable: true },
        { key: "codigoDiagnosticoRelacionado", sortable: true },
        { key: "codigoDiagnosticoComplicacion", sortable: true },
        { key: "formaRealizacionQx", sortable: true },
        { key: "total", sortable: true },
        { key: "identificador", sortable: true },
      ],
      currentPage: 1,
      perPage: 10,
      identifica: null,
      listaCups: [],
    };
  },
  async mounted() {
    await this.obtenerListaCups();
  },
  methods: {
    async obtenerCup() {
      const resCup = await this.$store.dispatch("denti_get", {
        path: "Cups/GetCupsPorIdentificador/" + this.itemSeleccionado,
      });
      this.listaRegistros = resCup;
      this.listaRegistros = this.listaRegistros.map((x) => {
        return {
          ...x,
          fechaProcedimiento: this.$moment.tz(x.fechaProcedimiento, "America/Bogota").format("DD/MM/YYYY"),
        };
      });
    },
    async obtenerListaCups() {
      const resCups = await this.$store.dispatch("denti_get", {
        path: "Cups/GetListaCups/",
      });
      this.listaCups = resCups;
    },
    generateReport() {
      let dataEncabezado = [
        "id2",
        "noFactura",
        "codigoPrestador",
        "tipoDocumento",
        "identificacion",
        "fechaProcedimiento",
        "numeroAutorizacion",
        "cups",
        "ambito",
        "finalidad",
        "personalAtiende",
        "cie10qx",
        "codigoDiagnosticoRelacionado",
        "codigoDiagnosticoComplicacion",
        "formaRealizacionQx",
        "total",
        "identificador",
      ];

      let data = this.listaRegistros.map(
        ({
          id2,
          noFactura,
          codigoPrestador,
          tipoDocumento,
          identificacion,
          fechaProcedimiento,
          numeroAutorizacion,
          cups,
          ambito,
          finalidad,
          personalAtiende,
          cie10qx,
          codigoDiagnosticoRelacionado,
          codigoDiagnosticoComplicacion,
          formaRealizacionQx,
          total,
          identificador,
        }) => [
          id2,
          noFactura,
          codigoPrestador,
          tipoDocumento,
          identificacion,
          fechaProcedimiento,
          numeroAutorizacion,
          cups,
          ambito,
          finalidad,
          personalAtiende,
          cie10qx,
          codigoDiagnosticoRelacionado,
          codigoDiagnosticoComplicacion,
          formaRealizacionQx,
          total,
          identificador,
        ]
      );
      let dataFull = [dataEncabezado, ...data];
      console.log(dataFull);
      const ws = XLSX.utils.aoa_to_sheet(dataFull);

      // Crear un nuevo libro de Excel y agregar la hoja
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Reporte");
      // Generar y descargar el archivo XLSX
      XLSX.writeFile(wb, "CUPS_" + this.itemSeleccionado + ".xlsx");
    },
    tablaSeleccionada() {
      console.log(this.tableName);
    },
  },
};
</script>

<style scoped>
.custom-popup {
  background-color: #f0f8ff;
  border-radius: 10px;
  padding: 1em;
  font-size: 1rem !important;
}

.custom-title {
  color: #333;
  font-size: 0.5rem !important;
  font-weight: bold;
}

.custom-input {
  border: 1px solid #ddd;
  padding: 0.5em;
  border-radius: 5px;
}

.custom-confirm-button {
  background-color: #4caf50;
  color: white;
  padding: 0.5em 1.5em;
}

.custom-cancel-button {
  background-color: #f44336;
  color: white;
}
</style>
